import PropTypes from 'prop-types';

import React from 'react';

import IconButton from '../ui/IconButton';

export default function SpellCheckButton(props) {
  return (
    <IconButton
      title="Проверить орфографию"
      // click event is not fired on draft.js editor focusout,
      // so need to use mousedown
      onMouseDown={props.onClick}
    >
      <svg width="31" height="18" viewBox="0 0 31 18" xmlns="http://www.w3.org/2000/svg">
        <g fill="#E1E1E1" fillRule="evenodd">
          <path d="M19.717 8.967c1 0 1.806-.264 2.417-.79.61-.528.95-1.25 1.017-2.169h-1.758c-.04.52-.193.903-.46 1.151-.268.248-.673.372-1.216.372-.602 0-1.042-.212-1.321-.638-.28-.426-.42-1.1-.42-2.022v-.644c.009-.883.158-1.534.449-1.954.29-.42.73-.63 1.315-.63.539 0 .94.124 1.205.372.263.248.417.647.459 1.198h1.758c-.093-.953-.441-1.693-1.043-2.22C21.518.464 20.725.2 19.739.2c-.71 0-1.334.167-1.871.501-.537.334-.95.814-1.24 1.44-.288.624-.432 1.346-.432 2.167v.521c0 1.285.313 2.296.94 3.033.627.736 1.487 1.104 2.58 1.104M3.176.319L0 8.849h1.87l.585-1.757h3.082L6.13 8.85H8L4.804.319H3.176zm.814 2.156l1.072 3.194H2.93L3.99 2.475zM13.028 7.142c-.232.197-.556.296-.97.296h-1.506V5.135h1.612c.808.012 1.213.408 1.213 1.19 0 .347-.117.62-.349.817zm-2.476-5.399h1.231c.484 0 .84.085 1.063.254.225.17.337.449.337.835 0 .692-.443 1.045-1.33 1.061h-1.3v-2.15zm4.582 4.599c0-.48-.126-.887-.377-1.219a1.805 1.805 0 0 0-1.035-.662c.383-.148.682-.382.897-.7.215-.318.322-.686.322-1.104 0-.766-.267-1.347-.803-1.744-.535-.396-1.32-.594-2.355-.594H8.795V8.85h3.316c.97-.008 1.715-.223 2.238-.645.524-.421.785-1.042.785-1.863z" />
          <path d="M29.026 4.6l-10.6 10.6-4.2-4.2-1.4 1.4 5.6 5.6 12-12z" />
        </g>
      </svg>
    </IconButton>
  );
}

SpellCheckButton.propTypes = {
  onClick: PropTypes.func,
};
